import React from 'react';
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

const AutoplayPlugin = (slider) => {
    let timeout;
    let mouseOver = false;

    function clearNextTimeout() {
        clearTimeout(timeout);
    }

    function nextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(() => {
            slider.next();
        }, 3000);
    }

    slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
        });
        slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
        });
        nextTimeout();
    });

    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
};

const SalesforceServices = ({ data }) => {
    const [sliderRef] = useKeenSlider({
        loop: true,
        breakpoints: {
            "(min-width: 768px)": {
                slides: { perView: 2, spacing: 20 },
            },
            "(min-width: 1024px)": {
                slides: { perView: 3, spacing: 28 },
            },
        },
        slides: { perView: 1, spacing: 20 },
    }, [AutoplayPlugin]);

    // Agar data nahi hai to render mat karo
    if (!data) return null;

    return (
        <section className="relative w-full bg-white py-16 lg:py-24 overflow-hidden">

            {/* SVG Background same rahega... */}
            <div className="absolute top-0 left-0 opacity-30 pointer-events-none">
                <svg width="400" height="300" viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {/* ... */}
                </svg>
            </div>

            <div className="max-w-[1440px] mx-auto px-6 lg:px-[80px] relative z-10">

                {/* Dynamic Heading */}
                <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora lg:mb-[80px] mb-[20px]">
                    {data.heading}
                </h2>

                <div ref={sliderRef} className="keen-slider">
                    {/* Dynamic Items Mapping */}
                    {data.items.map((service, index) => (
                        <div
                            key={index}
                            className="keen-slider__slide"
                        >
                            <div className='group relative flex flex-col h-[400px] bg-white border border-[#01386A45] hover:shadow-lg transition-all duration-300 lg:p-[40px] p-[20px] cursor-pointer overflow-hidden'>
                                <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#01386A]"></div>
                                <div className="absolute bottom-0 left-0 w-0 h-[3px] bg-[#ED6800] group-hover:w-full transition-all duration-500 ease-out z-10"></div>
                                <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[600] font-sora leading-[1.3] whitespace-pre-line mb-8">
                                    {service.title}
                                </h3>
                                <div className="relative flex-1">
                                    <p className="absolute inset-0 text-[#49577A] lg:text-[16px] text-[14px] leading-relaxed font-graphik font-[500] opacity-0 translate-x-12 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-500 ease-out">
                                        {service.desc}
                                    </p>
                                    <div className="absolute bottom-0 left-0 flex items-center gap-2 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                                        <span className="text-[#0F3057] text-[15px] font-[600] font-graphik underline underline-offset-4 decoration-1 decoration-[#0F3057]">
                                            Read More
                                        </span>
                                        <span className="text-[#F6821F] font-bold text-lg leading-none">
                                            &gt;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default SalesforceServices;